import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { NotFoundComponent } from './public/not-found/not-found.component';
import { AdminLayoutComponent } from './shared/admin-layout/admin-layout.component';
import { PublicLayoutComponent } from './shared/public-layout/public-layout.component';
import { UserLayoutComponent } from './shared/user-layout/user-layout.component';
import { OnlineEssayLayoutComponent } from './shared/online-essay-layout/online-essay-layout.component';
import { EssayGuard } from './shared/guards/essay.guard';
import { JudgeGuard } from './shared/guards/judge.guard';
import { TeacherGuard } from './shared/guards/teacher.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/public/login',
    pathMatch:"full"
  }, {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'public',
        loadChildren: () => import("./public/public.module").then(m => m.PublicModule),
        data: {title:"Public"}
      }
    ]
  }, {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'admin',
        loadChildren: () => import("./admin/admin.module").then(m => m.AdminModule),
        data: {title:"Admin"}
      }
    ]
  }, {
    path: "",
    component: UserLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'user',
        loadChildren: () => import("./user/user.module").then(m => m.UserModule),
        data: { title: "User" }
      }
    ]
  },{
    path: "",
    component: UserLayoutComponent,
    canActivate: [JudgeGuard],
    children: [
      {
        path: 'judge',
        loadChildren: () => import("./judge/judge.module").then(m => m.JudgeModule),
        data: { title: "Judge" }
      }
    ]
  },
  {
    path: "",
    component: UserLayoutComponent,
    canActivate: [TeacherGuard],
    children: [
      {
        path: 'teacher',
        loadChildren: () => import("./teacher/teacher.module").then(m => m.TeacherModule),
        data: { title: "Teacher" }
      }
    ]
  },
  {path: '404', component: NotFoundComponent},
 {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
